import React from 'react';
import CategoryTags from '../../components/CategoryTags';
import Favorite from '../../components/Favorite';
import SelectState from '../../components/SelectState';

function ScheduleItem({ scheduleChanger, config, schedule }) {
  const [canSelect, ] = React.useState(config.can_select);
  const [registrationMode, ] = React.useState(config.registration_mode);
  const [isSelectLock, ] = React.useState(!config.can_deselect);
  const dateFormatter = (opts) => new Intl.DateTimeFormat('en', opts);
  const startDate = new Date(schedule.start_date.replace(/-/g, '\/'));
  return (
    <div
      data-schedule-id={schedule.id}
      className='schedule-item'
      style={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        gap: '16px',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'min-content 1fr',
        }}
      >
        <div
          className='text-center'
          style={{
            fontSize: 16,
            fontWeight: 'bold',
            backgroundColor: '#f8f9fc',
            padding: '8px 24px',
          }}
        >
          <div>{dateFormatter({ weekday: 'long' }).format(startDate)}</div>
          <h5 style={{ margin: '4px 0px', fontSize: 20 }}>
            {dateFormatter({ day: '2-digit', month: 'short' }).format(
              startDate
            )}
          </h5>
          <div style={{ opacity: 0.5 }}>{schedule.time_start}</div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
          <div style={{ borderRight: '1px solid #f2f2f2' }}>&nbsp;</div>
          <div>&nbsp;</div>
        </div>
      </div>
      <div
        className='well'
        style={{
          backgroundColor: 'white',
          marginBottom: '12px',
          boxShadow: 'none',
          padding: '8px 16px',
        }}
      >
        <h4
          style={{
            textTransform: 'none',
            fontSize: 20,
            letterSpacing: 0,
          }}
        >
          {schedule.title}
          {canSelect || !isSelectLock ? (
            registrationMode ? (
              <SelectState scheduleChanger={scheduleChanger} config={config} scheduleItem={schedule} />
            ) : (
              <Favorite scheduleChanger={scheduleChanger} config={config} scheduleItem={schedule} />
            )
          ) : ("")
          }
        </h4>
        <div
          className='text-muted flex flex-row align-items-center'
          style={{ gap: 4, display: 'flex', fontSize: 14 }}
        >
          <i className='far fa-clock' />
          <div>
            {[
              schedule.time_start,
              ...(schedule.time_end ? [schedule.time_end] : []),
            ].join(' - ')} {config.time_zone}
          </div>
        </div>
        <CategoryTags tags={schedule.category_tags} />
        <p style={{ marginTop: 16 }}>{schedule.description}</p>
      </div>
    </div>
  );
}

export default ScheduleItem;
